import Moment from "moment"

export default function formatDateTime(date?:Moment | null, humanize?:boolean):string {
    if (!date) return ''

    if (humanize && date.isSame(Moment(),'day'))
        return "Today, " + date.format(gd.session.me.formatSettings.time)
    else
        return date.format("{0}, {1}".f(gd.session.me.formatSettings.date, gd.session.me.formatSettings.time))
}